import {
  Entity,
  EntityType,
  InvestmentJurisdiction,
} from '@shared/models/entity';
import { SecurityQuestionAnswer } from './security-question-answer';
import { SecurityStatus } from './security-status';
import { SecurityTaxResultItem } from './security-tax-result-item';
import { SecurityType } from './security-type';
import { TransactionType } from './transaction-type';

export class Security {
  securityId!: number;
  generalRateEntityTypeId?: number;
  generalRateEntityType?: EntityType;
  entity!: Entity;
  investmentJurisdiction!: InvestmentJurisdiction;
  transactionType!: TransactionType;
  securityType!: SecurityType;
  securityStatus!: SecurityStatus;
  securityTaxResultItems!: SecurityTaxResultItem[];
  name!: string;
  isinCusip!: string;
  ownership!: null;
  acquisitionDate!: Date;
  dispositionDate!: Date;
  isActive!: boolean;
  created!: Date;
  createdBy!: string;
  modified!: Date;
  modifiedBy!: string;
  comment!: string;
  adminComment?: string;
  adminCommentModifiedBy?: string;
  adminCommentModifiedDate?: Date | string;
  securityQuestionAnswers?: SecurityQuestionAnswer[];
}
